@if (authIsLoading$ | async) {
  <div>
    <app-page-loader></app-page-loader>
  </div>
} @else {
  <router-outlet></router-outlet>
}

